import type {JourneyAudienceAction} from 'src/action-creators/journey-audience';
import type {MemberCount, AudienceList} from 'src/types/audience-list';
import {
  UPDATE_STATE,
  RECEIVE_SELECTED_LISTS,
  SET_INCLUDED_LISTS,
  SET_EXCLUDED_LISTS,
  RESET,
  SET_MEMBER_COUNT,
  SET_MEMBER_COUNT_LOADING,
} from 'src/action-creators/journey-audience';


export type JourneyAudienceState = {
  includedLists: Map<string, Partial<AudienceList>>;
  excludedLists: Map<string, Partial<AudienceList>>;
  memberCounts: Map<string, Partial<MemberCount>>;
};

const initialState = {
  includedLists: new Map(),
  excludedLists: new Map(),
  memberCounts: new Map(),
} as const;

export default (
  state: JourneyAudienceState | null | undefined = initialState,
  action: JourneyAudienceAction,
): JourneyAudienceState => {
  switch (action.type) {
    case UPDATE_STATE: {
      // @ts-expect-error - TS2322 - Type '{ includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<string, Partial<AudienceList>> | undefined; memberCounts?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        ...action.payload,
      };
    }
    case RECEIVE_SELECTED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ includedLists: Map<string, Partial<AudienceList>>; excludedLists: Map<string, Partial<AudienceList>>; memberCounts?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        includedLists: new Map([
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.includedLists.entries(),
          ...action.payload.includedLists.entries(),
        ]),
        excludedLists: new Map([
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.excludedLists.entries(),
          ...action.payload.excludedLists.entries(),
        ]),
      };
    }
    case SET_INCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ includedLists: Map<string, Partial<AudienceList>>; excludedLists?: Map<string, Partial<AudienceList>> | undefined; memberCounts?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        includedLists: action.payload,
      };
    }
    case SET_EXCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ excludedLists: Map<string, Partial<AudienceList>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; memberCounts?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        excludedLists: action.payload,
      };
    }
    case SET_MEMBER_COUNT_LOADING: {
      const {listIds = [], isLoading = false} = action.payload ?? {};
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const newMemberCount = new Map(state.memberCounts);
      listIds.forEach((id) => {
        const listData = newMemberCount.get(String(id));
        newMemberCount.set(String(id), {...listData, isLoading});
      });

      // @ts-expect-error - TS2322 - Type '{ memberCounts: Map<string, Partial<MemberCount>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        memberCounts: newMemberCount,
      };
    }
    case SET_MEMBER_COUNT: {
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const currentMemberCount = state.memberCounts;
      const newMemberCount = new Map(currentMemberCount);
      for (const [key, value] of action.payload) {
        const currentData = currentMemberCount.get(String(key));
        newMemberCount.set(String(key), {
          ...currentData,
          ...value,
          isLoading: false,
        });
      }

      // @ts-expect-error - TS2322 - Type '{ memberCounts: Map<string, Partial<MemberCount>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<...> | undefined; }' is not assignable to type 'JourneyAudienceState'.
      return {
        ...state,
        memberCounts: newMemberCount,
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'JourneyAudienceState | null' is not assignable to type 'JourneyAudienceState'.
  return state;
};
